import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {FlowRessourceObject} from "@app/netscope/model/data-models";
import {
  AppGroupState,
  isAppsGroupFolded
} from "@app/netscope/netscope-common-flowview/netscope-common-flowview.component";
import {AppsGroupFlowsStatus, FlowViewHost} from "@app/netscope/netscope-common-flowview/flowview-host";
import {ClrCommonFormsModule, ClrSignpostModule} from "@clr/angular";


@Component({
  standalone: false,
  selector: 'app-apps-group-element',
  // imports: [
  //   ClrSignpostModule,
  //   ClrCommonFormsModule,
  // ],
  templateUrl: './apps-group-element.component.html',
  styleUrl: './apps-group-element.component.css'
})
export class AppsGroupElementComponent {
  @Input() appGroup: FlowRessourceObject;
  @Input() flowComponent: FlowViewHost;

  @Output() descriptionChanged = new EventEmitter<string>();

  modalOpen = false;
  options = false;

  onMembersDisplayModeChange = (event) => {
    if (! this.flowComponent.appGroupStates.has(this.appGroup.name)) {
      let newAppGroupState: AppGroupState = new AppGroupState();
      newAppGroupState.name = this.appGroup.name;
      newAppGroupState.mode = this.appGroup.membersDisplayMode;
      this.flowComponent.appGroupStates.set(this.appGroup.name, newAppGroupState);
    }
    let appGroupState = this.flowComponent.appGroupStates.get(this.appGroup.name);
    appGroupState.mode = this.appGroup.membersDisplayMode;
    // The mode is a preset over the visibility of the members, which is what the renderer reads back
    this.flowComponent.applyAppGroupMode(this.appGroup.appsGroupObject, this.appGroup.membersDisplayMode);
    this.flowComponent.renderer.destroy(this.flowComponent);
    this.flowComponent.renderer.render(this.flowComponent);
  }

  showAppGroupSettings = (appGroup: FlowRessourceObject) => {
    this.flowComponent.showAppGroupSettings(appGroup)
  }

  get folded(): boolean {
    return isAppsGroupFolded(this.flowComponent, this.appGroup.name);
  }

  // What a folded group holds, as it shows none of it
  get foldedSummary(): string {
    let membersCount = (this.appGroup.appsGroupObject?.vms ?? []).length;
    let groupsCount = (this.appGroup.appsGroupObject?.resolvedInclusions ?? []).length;
    let parts = [membersCount == 1 ? "1 member" : `${membersCount} members`];
    if (groupsCount > 0) {
      parts.push(groupsCount == 1 ? "1 group inside" : `${groupsCount} groups inside`);
    }
    return parts.join(" · ");
  }

  // Whether the group exchanged flows, as the renderer found while drawing it
  get flowsStatus(): AppsGroupFlowsStatus {
    return this.flowComponent.appsGroupsFlowsStatus?.get(this.appGroup.uuid) ?? "flows";
  }

  get selected(): boolean {
    return this.flowComponent.selectedAppsGroupName != undefined
      && this.flowComponent.selectedAppsGroupName == this.appGroup.name
      && this.flowComponent.selectedIncludedAppsGroupKey == undefined;
  }

  toggleFolded = (event: Event) => {
    // The box sits inside the paper, which would otherwise take the click for the start of a drag
    event.stopPropagation();
    this.flowComponent.toggleAppsGroupFolded(this.appGroup.appsGroupObject);
  }
}
